export default [
  {
    path: '/reservados',
    name: 'reservados',
    component: () => import(/* webpackChunkName: "reservados" */ './Reservados.vue'),
    children: [
      {
        path: '/reservados/listaReservados',
        name: 'listaReservados',
        components: {
          reservadoRouter: () => import(/* webpackChunkName: "reservados" */ '@/components/reservar-protocolo/ListaReservado.vue')
        }
      }
    ]
  }
]
